module.exports = __webpack_public_path__ + "img/線形代数_01_01.589eeabf.png";